import { createSlice } from '@reduxjs/toolkit';
import axios from 'axios';
import { fetchAuthSession } from 'aws-amplify/auth';
import { apiGateway } from '../../../../config';
import { itemAPI } from '../api/itemAPI';

import type { AxiosResponse } from 'axios';
import type { PayloadAction } from '@reduxjs/toolkit';
import type { AppThunk } from '../../../../redux/store';
import type { ErrorResponse, Factory, Item } from 'src/@types/common';
import type { ItemState } from 'src/@types/item';

// ----------------------------------------------------------------------

const initialState: ItemState = {
  isLoading: false,
  hasError: false,
  hasSearched: false,
  message: undefined,
  options: {
    factory: [],
  },
  items: undefined,
  item: undefined,
};

const slice = createSlice({
  name: 'generalItem',
  initialState,
  reducers: {
    startLoading(state: ItemState) {
      state.isLoading = true;
    },

    resetMessage(state: ItemState) {
      state.isLoading = false;
      state.hasError = false;
      state.message = '';
    },

    itemReset: () => initialState,
    getItemSuccess(state: ItemState, action: PayloadAction<Item[]>) {
      state.isLoading = false;
      state.hasError = false;
      state.message = undefined;
      state.items = action.payload;
    },
    hasError(state: ItemState, action: PayloadAction<string>) {
      state.isLoading = false;
      state.hasError = true;
      state.message = action.payload;
    },
    //
    showMessage(state: ItemState, action: PayloadAction<string>) {
      state.isLoading = false;
      state.hasError = false;
      state.message = action.payload;
    },

    setFactories(state: ItemState, action: PayloadAction<Factory[]>) {
      state.isLoading = false;
      state.hasError = false;
      state.options.factory = action.payload;
    },

    setItem(state: ItemState, action: PayloadAction<Item>) {
      state.isLoading = false;
      state.hasError = false;
      // console.log('🈲', action.payload);
      state.item = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const { itemReset } = slice.actions;
/**
 *目標の操作を行う
 *@param {ModalStatus} type ダイアログの状態
 *@param {any} values Excelのデータ
 *@callback onSuccess 成功
 *@callback onFailure 失敗
 */
export const handleItem = async (
  values: FormData,
  callbacks: {
    onSuccess: (res: any) => void;
    onFailure: (err: any) => void;
  },
) => {
  return await itemAPI
    .getItemList(values)
    .then((res) => {
      callbacks.onSuccess(res);
    })
    .catch((err) => {
      callbacks.onFailure(err);
    });
};

export function getItems(dateFrom?: string, dateTo?: string, limit?: number): AppThunk {
  return async (dispatch): Promise<void> => {
    dispatch(slice.actions.startLoading());
    try {
      const token = (await fetchAuthSession()).tokens?.idToken?.toString();
      const response: AxiosResponse = await axios.get<Item[]>(apiGateway + '/item?filter={"orderBy":{"displayOrder":"asc"}}', {
        headers: {
          Authorization: 'Bearer ' + token,
        },
        timeout: 60000,
      });
      dispatch(slice.actions.getItemSuccess(response.data));
    } catch (error) {
      // console.log(error);

      // TODO:以下のエラー処理を有効化
      if (axios.isAxiosError(error)) {
        // error: AxiosError
        if (error.response) {
          const serverResponse: ErrorResponse = error.response.data;
          dispatch(slice.actions.hasError(serverResponse.message));
        } else {
          dispatch(slice.actions.hasError(error.message));
        }
      } else {
        if (error instanceof Error) {
          // error: Error
          dispatch(slice.actions.hasError(error.message));
        } else {
          const message = 'Unknown error';
          dispatch(slice.actions.hasError(message));
        }
      }
    }
  };
}

export function resetMessage(): AppThunk {
  return (dispatch): void => {
    dispatch(slice.actions.resetMessage());
  };
}

export function getFactoryOptions(): AppThunk {
  return async (dispatch): Promise<void> => {
    dispatch(slice.actions.startLoading());
    // try {
    const token = (await fetchAuthSession()).tokens?.idToken?.toString();
    const response: AxiosResponse = await axios.get<Factory[]>(apiGateway + '/options/factory', {
      headers: {
        Authorization: 'Bearer ' + token,
      },
      timeout: 60000,
    });
    // console.log('🏰factory', response);
    dispatch(slice.actions.setFactories(response.data));
  };
}


export function updateItem(item: Item): AppThunk {
  return async (dispatch): Promise<void> => {
    dispatch(slice.actions.startLoading());
    // try {
    const token = (await fetchAuthSession()).tokens?.idToken?.toString();
    const response: AxiosResponse = await axios.put<Item>(apiGateway + '/item/'+item.code, item, {
      headers: {
        Authorization: 'Bearer ' + token,
      },
      timeout: 60000,
    });
    // console.log('🏰response', response);
    dispatch(slice.actions.showMessage('successfully updated'));
  }
}

export function createItem(item: Item): AppThunk {
  return async (dispatch): Promise<void> => {
    dispatch(slice.actions.startLoading());
    // try {
    const token = (await fetchAuthSession()).tokens?.idToken?.toString();
    const response: AxiosResponse = await axios.post<Item>(apiGateway + '/item', item, {
      headers: {
        Authorization: 'Bearer ' + token,
      },
      timeout: 60000,
    });
    // console.log('🏰response', response);
    dispatch(slice.actions.showMessage('successfully created'));

    // } catch (error) {
    //   console.log('🐱', error);

    //   // TODO:以下のエラー処理を有効化
    //   if (axios.isAxiosError(error)) {
    //     // error: AxiosError
    //     if (error.response) {
    //       const serverResponse: ErrorResponse = error.response.data;
    //       dispatch(slice.actions.hasError(serverResponse.message));
    //     } else {
    //       dispatch(slice.actions.hasError(error.message));
    //     }
    //   } else {
    //     if (error instanceof Error) {
    //       // error: Error
    //       dispatch(slice.actions.hasError(error.message));
    //     } else {
    //       const message = 'Unknown error';
    //       dispatch(slice.actions.hasError(message));
    //     }
    //   }
    // }

    // setTimeout(() => {
    //   dispatch(slice.actions.getItemSuccess(itemData));
    // } , 2000);
  };
}


  export function _findItem(itemCode: string): AppThunk {
  return async (dispatch): Promise<Item> => {
    // dispatch(slice.actions.startLoading());
    // try {
    const token = (await fetchAuthSession()).tokens?.idToken?.toString();
    const response: AxiosResponse = await axios.get<Item>(apiGateway + '/item/' + itemCode, {
      headers: {
        Authorization: 'Bearer ' + token,
      },
      timeout: 60000,
    });
    return response.data;
    
    // let itemArray: Item[] = [];
    // itemArray.push(response.data);
    // console.log('🈲item response', itemArray);

    //dispatch(slice.actions.setItem(item));
  };
}

export default slice.reducer;
